export class Money {
    public static format(price: number, currency: string): string {
        let currencySign = "€";
        if (currency === "GBP") currencySign = "£";
        if (currency === "USD") currencySign = "$";
        return (
            currencySign +
            Number(price / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        );
    }
}
